import React from "react";

import "./styles/backoffice.scss";

function BackofficeHome() {
  return <div className="home-component"></div>;
}

export default BackofficeHome;
